export default function mapData(data, partnerId, itemType, itemId) {
    return {
        agreement: {
            data: data.agreement,
        },
        partner: {
            ...data.partner,
            id: partnerId,
        },
        payment: {
            data: data.payment || {},
        },
        safeTrade: {
            acceptanceTimeLimitInMinutes: data.acceptanceTimeLimitInMinutes,
            feePercentage: data.feePercentage,
            itemType,
            itemId,
            maxAmount: data.maxAmount,
            viewStatus: data.viewStatus,
        },
        user: data.user,
        withdrawal: data.withdrawal,
    };
}



// WEBPACK FOOTER //
// ./safeTrade/responseMapper.js